import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { corporateClientsAPI } from "api/api/corporateClientsApi/corporateClientsApi";
import { GetCorporateClientsWithVouchersByMarathonIdParams, GetCorporateClientsWithVouchersByMarathonIdRes } from "api/api/corporateClientsApi/types";

export const getCorporateClientsWithVouchersByMarathonId = createAsyncThunk<
  GetCorporateClientsWithVouchersByMarathonIdRes,
  GetCorporateClientsWithVouchersByMarathonIdParams
>(
  `statuses/getCorporateClientsWithVouchersByMarathonId`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await corporateClientsAPI.getCorporateClientsWithVouchersByMarathonId(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting statuses comments",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting statuses comments", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);